import type { Pluggable, Plugin } from 'unified';
import type { Options as SanitizerOptions } from 'rehype-sanitize';
import type { Options as ExternalLinkOptions } from 'rehype-external-links';
import type { Options as RemarkRehypeOptions } from 'remark-rehype';

export type MarkdownToHtmlPlugin = Pluggable;
export type UnifiedPlugin = Plugin;
export type { SanitizerOptions, ExternalLinkOptions };
export type RemarkRehypePluginOptions = RemarkRehypeOptions;

export const PLUGIN_IMPORTS_OBJ: Record<string, () => Promise<{ default: MarkdownToHtmlPlugin }>> = {
  'remark-parse': () => import('remark-parse'),
  'remark-gfm': () => import('remark-gfm'),
  'remark-rehype': () => import('remark-rehype'),
  'rehype-raw': () => import('rehype-raw'),
  'rehype-parse': () => import('rehype-parse'),
  'rehype-stringify': () => import('rehype-stringify'),
  'rehype-sanitize': () => import('rehype-sanitize'),
  'rehype-slug': () => import('rehype-slug'),
  'rehype-external-links': () => import('rehype-external-links'),
};

export type PluginName = keyof typeof PLUGIN_IMPORTS_OBJ;
export type PluginOptions = SanitizerOptions | ExternalLinkOptions | RemarkRehypePluginOptions;
export type PluginEntry = PluginName | [PluginName, PluginOptions];
